export default "__VITE_ASSET__23676fda__"